module.exports = __webpack_public_path__ + "img/ttshop_dfh1.6a7bba08.svg";